export const DEFAULT_CAMERA_FAR = 20;
export const DEFAULT_CAMERA_FOV = 28;
export const DEFAULT_CAMERA_NEAR = 0.01;
